import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiConfirmSection from "../foto-multi-confirm-section/FotoMultiConfirmSection";
import { AngularPhotoType, CarPositionsEnum } from "../../types/carTypes";
import frontLeftSvg from '../../assets/svg/foto-angolari/front-left.svg'
import rearLeftSvg from '../../assets/svg/foto-angolari/rear-left.svg'
import rearRightSvg from '../../assets/svg/foto-angolari/rear-right.svg'
import frontRightSvg from '../../assets/svg/foto-angolari/front-right.svg'
import EsempiFotoAngolareVeicolo from "./EsempiFotoAngolareVeicolo";
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";
import { computeNextPhotoIndex } from "../../utils/utils-file";

const TOT_FOTO_ANGOLARE_VEICOLO = 4

const itemsAngolari: AngularPhotoType[] = [{
    code: CarPositionsEnum.FRONT_LEFT,
    labelTxt: 'Angolo anteriore sinistro',
    imgSrc: frontLeftSvg,
    liqDescription: 'FP - Anteriore sinistra',
}, {
    code: CarPositionsEnum.BOTTOM_LEFT,
    labelTxt: 'Angolo posteriore sinistro',
    imgSrc: rearLeftSvg,
    liqDescription: 'FP - Posteriore sinistra',
}, {
    code: CarPositionsEnum.BOTTOM_RIGHT,
    labelTxt: 'Angolo posteriore destro',
    imgSrc: rearRightSvg,
    liqDescription: 'FP - Posteriore destra',
}, {
    code: CarPositionsEnum.FRONT_RIGHT,
    labelTxt: 'Angolo anteriore destro',
    imgSrc: frontRightSvg,
    liqDescription: 'FP - Anteriore destra',
}]

/* istanbul ignore next */
const FotoAngolareVeicolo = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoAngolareVeicolo, setFotoAngolareVeicolo] = useState<FileItemType[]>(communication.fotoAngolareVeicolo)

    const numPhotos = fotoAngolareVeicolo?.length
    const leftLabelCmp = <p className="left-label-item">{`${numPhotos + 1} foto di ${TOT_FOTO_ANGOLARE_VEICOLO}`}</p>

    const nextPhotoIndex = computeNextPhotoIndex(fotoAngolareVeicolo, itemsAngolari)
    const itemAng = itemsAngolari[nextPhotoIndex]
    const labelTxt = nextPhotoIndex < TOT_FOTO_ANGOLARE_VEICOLO ? itemAng?.labelTxt : null
    const labelItem = labelTxt && <p className="mail-label">{labelTxt}</p>

    const overlaySuggestItem = <div className="suggest-item-conteiner">
        <img src={itemAng?.imgSrc} alt={itemAng?.labelTxt} />
    </div>

    const _liqDescription = itemAng?.liqDescription || null

    return (
        <>
            <EsempiFotoAngolareVeicolo />
            <FotoMultiConfirmSection
                fileType={PhotoTypeEnum.ANGOLARE_VEICOLO_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.ANGOLARE_VEICOLO_DOCS],
                    liqDescription: _liqDescription,
                    detailCode: itemAng?.code
                }}
                files={fotoAngolareVeicolo}
                setFiles={setFotoAngolareVeicolo}
                arrayDbPropSync={"fotoAngolareVeicolo"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto del tuo veicolo"}
                totPhotosForStepDone={TOT_FOTO_ANGOLARE_VEICOLO}
                leftLabelCmp={leftLabelCmp}
                mainLabelItem={labelItem}
                overlaySuggestItem={overlaySuggestItem}
                addButtonInLastPlace={true}
            />
        </>
    )
}

export default FotoAngolareVeicolo